// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';
import {Input, Output, EventEmitter, ElementRef, inject, OnChanges, SimpleChanges} from '@angular/core';
import type {Item} from '../../libs/infra';
import {inputTypes, changeInputType} from '../../libs/template-input-editor';
const wiz = new Wiz({ appId: 'component.template-input-editor', namespace: 'template-input-editor' });
@AngularComponent({
  selector: 'wiz-template-input-editor',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class ComponentTemplateInputEditorComponent implements OnChanges {
  @Input() inputs: Item[] = [];
  @Output() inputsChange = new EventEmitter<Item[]>();
  @Input() selectedIndex = 0;
  @Output() selectedIndexChange = new EventEmitter<number>();
  public readonly types = inputTypes;
  public readonly standalone = {standalone:true};
  public removed: {input:Item; index:number} | null = null;
  private element = inject(ElementRef<HTMLElement>);
  public get input(): Item | undefined { return this.inputs[this.selectedIndex]; }
  public get type(): string { return this.input?.type || 'string'; }
  public get hasDefault(): boolean { return this.input?.default !== undefined && this.input?.default !== null; }
  public get enumDefault(): any { return this.input?.options?.find((option:any) => String(option) === String(this.input?.default)); }
  public index(index:number): number { return index; }
  public typeLabel(input:Item): string { return this.types.find(type => type.value === (input.type || 'string'))?.label || input.type; }
  public ngOnChanges(changes:SimpleChanges): void {
    if (changes['selectedIndex']) this.resetScroll();
  }
  private resetScroll(): void {
    requestAnimationFrame(() => {
      const editor=this.element.nativeElement.querySelector<HTMLElement>('.input-editor');
      if (editor) editor.scrollTop=0;
    });
  }
  public select(index:number): void { this.selectedIndex=index;this.selectedIndexChange.emit(index);this.resetScroll(); }
  private emit(inputs:Item[]): void { this.inputs=inputs;this.inputsChange.emit(inputs); }
  private replace(input:Item): void { this.emit(this.inputs.map((current,index) => index === this.selectedIndex ? input : current)); }
  public set(key:string,value:any,optional=false): void {
    const input={...this.input};
    if (optional && (value === '' || value === null)) delete input[key]; else input[key]=value;
    this.replace(input);
  }
  public setType(type:string): void { if(this.input)this.replace(changeInputType(this.input,type)); }
  public defaultEnabled(enabled:boolean): void {
    if (!enabled) {const input={...this.input};delete input.default;this.replace(input);return;}
    this.set('default',this.type === 'boolean' ? false : this.type === 'number' ? (this.input?.minimum ?? 0) : this.type === 'enum' ? (this.input?.options?.[0] ?? '') : '');
  }
  public add(): void {
    this.emit([...this.inputs,{key:'',label:'',type:'string'}]);this.select(this.inputs.length-1);
    setTimeout(()=>this.element.nativeElement.querySelector<HTMLInputElement>('[aria-label="표시 이름"]')?.focus());
  }
  public remove(): void {
    if (!this.input) return;
    this.removed={input:this.input,index:this.selectedIndex};
    this.emit(this.inputs.filter((_,index)=>index!==this.selectedIndex));this.select(Math.max(0,this.selectedIndex-1));
    setTimeout(()=>this.element.nativeElement.querySelector<HTMLButtonElement>('.undo-remove')?.focus());
  }
  public undoRemove(): void {
    if (!this.removed) return;
    const inputs=[...this.inputs],index=Math.min(this.removed.index,inputs.length);
    inputs.splice(index,0,this.removed.input);this.emit(inputs);this.select(index);this.removed=null;
  }
  public move(offset:number): void {
    const index=this.selectedIndex+offset;
    if(index<0 || index>=this.inputs.length)return;
    const inputs=[...this.inputs];[inputs[index],inputs[this.selectedIndex]]=[inputs[this.selectedIndex],inputs[index]];
    this.emit(inputs);this.select(index);
  }
  public setOption(index:number,value:string): void { const options=[...(this.input?.options || [])];options[index]=value;this.set('options',options); }
  public addOption(): void {
    this.set('options',[...(this.input?.options || []),'']);
    setTimeout(()=>this.element.nativeElement.querySelector<HTMLInputElement>('.option-row:last-child input')?.focus());
  }
  public removeOption(index:number): void { this.set('options',this.input?.options.filter((_:any,i:number)=>i!==index)); }
}

export default ComponentTemplateInputEditorComponent;
